import { find, map } from "lodash";
import { SelectedTicketInfo } from "../logic/models";
import { PriceGroupsByEventDateId, TicketPriceSingleSelectionPanel } from "./models/buyticket";
import { AddToCartPackageRequest, AddToCartRequest, AddToCartRequestBase, PriceQuantity } from "../mvcapi/models/buyticket/ticketselection";
import { SiteSettings } from "@tsinternetsale/common";
import { AddToCartItem, AddToCartItemType, AddToCartPackageItem, AddToCartTicketItem, getTicketIdsFromItems, getTicketsFromItem } from "../stores/add-to-cart-stores/models/add-to-cart-items";
import { PriceGroupModel } from "../mvcapi/models/buyticket";
import produce from "immer";

export type TicketCummul = {
    total: number;
    fees: number;
}
/**
 * 
 * @param selectedAddToCartItems Doivent être des billets de la même section. Le premier item est utilisé pour déterminer si c'est un package ou non.
 * @param addToCartRequest 
 * @returns 
 */
export async function getTicketPriceSingleSelectionPanel(selectedAddToCartItems: AddToCartItem[], addToCartRequest: AddToCartRequestBase, selectedEventDateIds: number[]) {
    try {
        if(selectedAddToCartItems.length === 0) return null;

        const packageId = selectedAddToCartItems[0].type == (AddToCartItemType.Package) ? (selectedAddToCartItems[0] as AddToCartPackageItem).packageId : 0;

        let result: TicketPriceSingleSelectionPanel;
        if(packageId === 0) {
            result = await tsapp.mvcapi.postCtl("chooseticketprice/pricelistbyticketids", { 
                selectedTicketIds: getTicketIdsFromItems(selectedAddToCartItems),
                addToCartRequest: addToCartRequest as AddToCartRequest,
                selectedEventDateIds: selectedEventDateIds
            });
        } else {
            result = await tsapp.mvcapi.postCtl("chooseticketprice/packagepricelistbyticketids", { 
                packageId: packageId,
                selectedTicketIds: getTicketIdsFromItems(selectedAddToCartItems),
                addToCartRequest: addToCartRequest as AddToCartPackageRequest,
                selectedEventDateIds: selectedEventDateIds
            });
        }
        return result;
    } catch (err) {
        //TODO: Handle properly the error here
        console.log("ERROR", err);
    }
    return null;
}

export function getAllAddToCartItemsByEventDateId(items: AddToCartItem[]): {[key: number]: AddToCartItem[]} {
    return items.reduce((acc, item: AddToCartTicketItem) => { 
        if(acc[item.eventDateId] == undefined) acc[item.eventDateId] = [];
        acc[item.eventDateId].push(item);
        return acc;
    }, {} as {[key: number]: AddToCartItem[]});
}
export function getSelectedLastPriceGroup(selectedPriceGroup: PriceGroupModel, priceGroups: PriceGroupModel[]): PriceGroupModel {
    let pg = priceGroups.find(pg => pg.ID === selectedPriceGroup?.ID);

    if(pg && pg.Disabled) {
        if(priceGroups.length === 1) 
            pg = priceGroups[0];
    }

    return pg;
}


export function distributePriceGroupInsidePackageItems(packageItems: AddToCartPackageItem[], pricesQty: PriceQuantity[], priceGroupsByEventDateId: PriceGroupsByEventDateId): AddToCartItem[] {
    return produce(packageItems, draft => {
        let j = 0;
        pricesQty.forEach((priceQty) => {
            for (let i = 0; i < priceQty.quantity; i++) {
                let packageItem = draft[j];
                
                packageItem.packageDateItems.forEach(item => {
                    const priceList = priceGroupsByEventDateId[item.eventDateId];
                    const priceGroup = find(priceList, { Name: priceQty.priceGroup.Name });

                    item.ticket.pricegroup = priceGroup;
                    item.ticket.priceId = priceGroup.PriceID;
                });

                j++;
            }
        });
    });
}

export function distributePriceGroupInsideTicketItems(ticketItems: AddToCartTicketItem[], pricesQty: PriceQuantity[]): AddToCartItem[] {
    return produce(ticketItems, draft => {
        let j = 0;
        pricesQty.forEach((priceQty) => {
            
            for (let i = 0; i < priceQty.quantity; i++) {
                let ticketItem = draft[j];

                ticketItem.ticket.pricegroup = priceQty.priceGroup;
                ticketItem.ticket.priceId = priceQty.priceGroup.PriceID;
                
                j++;
            }
        });
    });
}

export function distributeTicketPriceGroup(tickets: SelectedTicketInfo[], pricesQty: PriceQuantity[]): SelectedTicketInfo[] {
    const allTicketIds = map(tickets, "ticket.TicketID");
    let newSelectedTickets: SelectedTicketInfo[] = [];
    let j = 0;
    pricesQty.forEach((priceQty) => {
        for (let i = 0; i < priceQty.quantity; i++) {
            const selectedTicket = tickets.find(t => t.ticketId === allTicketIds[j]);
            const alreadyAdded = newSelectedTickets.find(t => t.ticketId === selectedTicket.ticketId) != undefined;
            if (!alreadyAdded) {
                newSelectedTickets.push({
                    ticketId: allTicketIds[j],
                    ticket: selectedTicket.ticket,
                    priceId: priceQty.priceGroup.PriceID,
                    pricegroup: priceQty.priceGroup,
                });
            }
            j++;
        }
    });
    return newSelectedTickets;
}

// export function getTicketPriceTotalAndFees(selectedTickets: SelectedTicketInfo[]): TicketCummul {
//     const totalAndFees: TicketCummul = { total: 0, fees: 0};
//     selectedTickets.forEach((ticket) => {
//         if(ticket.pricegroup){
//             totalAndFees.total += ticket.pricegroup.Total;
//             totalAndFees.fees += ticket.pricegroup.Fees;
//         }
//     });
//     return totalAndFees;
// }

export function getSelectionItemsTotalAndFees(items: AddToCartItem[], siteSettings: SiteSettings): TicketCummul {
    const totalAndFees: TicketCummul = { total: 0, fees: 0 };

    items.forEach((item) => {
            getTicketsFromItem(item)
                .filter(t => t.pricegroup)
                .forEach((ticket) => {
                    totalAndFees.total += siteSettings.taxesOnlyAtCheckout ? ticket.pricegroup.TotalBeforeTaxes : ticket.pricegroup.Total;
                    totalAndFees.fees += siteSettings.taxesOnlyAtCheckout ? ticket.pricegroup.FeesBeforeTaxes : ticket.pricegroup.Fees;
                }
            );
    });

    return totalAndFees;
}

